import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { PROJECTS_API } from '../config/general.config';
import { Observable } from 'rxjs';
import { Project } from '../model/project.model';
import { OrderModel } from '../model/order.model';
import { FormModel } from '../modules/settings/model/form.model';
import { MapModel } from '../model/map.model';
import { Task } from '../modules/go/model/task.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  private projectsApi = PROJECTS_API;

  private ordersApi(projectUuid: string): string {
    return `${this.projectsApi}/${projectUuid}/orders`;
  }

  private formsApi(projectUuid: string): string {
    return `${this.projectsApi}/${projectUuid}/forms`;
  }

  private dataApi(projectUuid: string): string {
    return `${this.projectsApi}/${projectUuid}/data`;
  }

  constructor(
    private _http: HttpClient
  ) { }

  getProjects(): Observable<Project[]> {
    return this._http.get<Project[]> (this.projectsApi);
  }

  getProject(projectId: string): Observable<Project> {
    return this._http.get<Project> (`${this.projectsApi}/${projectId}`);
  }

  getAllOrders(projectId: string): Observable<OrderModel[]> {
    return this._http.get<OrderModel[]>(this.ordersApi(projectId) + '/all');
  }

  getActiveOrders(projectId: string): Observable<OrderModel[]> {
    return this._http.get<OrderModel[]>(this.ordersApi(projectId) + '/current');
  }

  getArchivedOrders(projectId: string): Observable<OrderModel[]> {
    return this._http.get<OrderModel[]>(this.ordersApi(projectId) + '/archived');
  }

  getExternalOrders(projectId: string): Observable<OrderModel[]> {
    return this._http.get<OrderModel[]>(this.ordersApi(projectId) + '/external');
  }

  getClosedOrders(projectId: string): Observable<OrderModel[]> {
    return this._http.get<OrderModel[]>(this.ordersApi(projectId) + '/closed');
  }

  getOrdersForReport(projectId: string): Observable<OrderModel[]> {
    return this._http.get<OrderModel[]>(this.ordersApi(projectId) + '/for-reports');
  }

  getForms(projectId: string): Observable<FormModel[]> {
    return this._http.get<FormModel[]>(this.formsApi(projectId));
  }

  getMapData(projectId: string): Observable<MapModel> {
    return this._http.get<MapModel>(`${this.projectsApi}/${projectId}/map`);
  }

  getTowersHeaders(projectId: string): Observable<string[]> {
    return this._http.get<string[]>(this.dataApi(projectId) + '/towers/headers')
  }

  getSpansHeaders(projectId: string): Observable<string[]> {
    return this._http.get<string[]>(this.dataApi(projectId) + '/spans/headers')
  }

  getProjectsWithSimilarTask(taskId: number): Observable<Project[]> {
    return this._http.get<Project[]>(this.projectsApi + '/with-similar-opened-tasks/' + taskId);
  }

  getSimilarTasksForProject(projectId: string, taskId: number): Observable<Task[]> {
    return this._http.get<Task[]>(`${this.projectsApi}/${projectId}/tasks/similar-to/${taskId}`)
  }
}
